// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7,
// bespoke-menus wave): MenuPanel shell + MenuPanelItem rows. Deleted with the
// re-chassis: the hand-rolled `theme: 'navbar'` + `padding: 'Y1 Z2'` shell
// chrome (MenuPanel owns the dialog surface + Y padding — the navbar glass was
// the pre-§7.7 recipe), the `margin: '- -Z2'` list pull (it compensated that
// padding; under the MenuPanel Y body it would overflow by Z2 − Y and clip
// against the Dropdown wrapper's overflow), the `':hover': { '& svg': … }`
// opacity armor + per-row Icon color/opacity/weight games (they fought the
// retired KeyValueColumnFields/DropdownItem chassis) and the hand-rolled row
// chrome (MenuPanelItem owns the row recipe).
export const PreviewModesMenu = {
  extends: 'MenuPanel',
  gap: 'A',
  Items: {
    flow: 'y',
    gap: '0',
    childExtends: 'MenuPanelItem',
    childProps: {
      Icon: {
        order: '-1',
        margin: '- Y1 - -'
      }
    },
    childrenAs: 'props',
    children: (el) => [
      {
        text: '{{ editor.previewModes.newTab | polyglot }}',
        Icon: {
          name: 'arrow up right'
        },
        onClick: 'openInNewTab'
      },
      {
        text: '{{ editor.previewModes.localRender | polyglot }}',
        Icon: {
          name: 'playOvalDotted'
        },
        onClick: (ev, el, s) => {
          el.openModal('/browser-preview')
        }
      },
      {
        text: '{{ editor.previewModes.remotePreview | polyglot }}',
        Icon: {
          name: 'network'
        },
        onClick: (ev, el, s) => {
          el.openModal('/browser-preview')
        }
      }
    ]
  }
}
